import { render, staticRenderFns } from "./shopCouponManage.vue?vue&type=template&id=1a84456c&scoped=true"
import script from "./shopCouponManage.vue?vue&type=script&lang=js"
export * from "./shopCouponManage.vue?vue&type=script&lang=js"
import style0 from "./shopCouponManage.vue?vue&type=style&index=0&id=1a84456c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a84456c",
  null
  
)

export default component.exports